module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_smoker_right-c4838fee757561348f5d57d7d5536fc7.png";